import { render, staticRenderFns } from "./shareH5.vue?vue&type=template&id=2e908b64&scoped=true&"
import script from "./shareH5.vue?vue&type=script&lang=js&"
export * from "./shareH5.vue?vue&type=script&lang=js&"
import style0 from "./shareH5.vue?vue&type=style&index=0&id=2e908b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e908b64",
  null
  
)

export default component.exports